module.exports = __webpack_public_path__ + "static/img/banner@2x.76faad9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner@2x.png
// module id = c63e207e422c30b8
// module chunks = 59